export const SW_VERSION = "4fc8140a57edebb3607876eeb6cde366";